<template>
  <section class="z-grid v-page-section-container-padding-wide-screens container col-span-full mb-8 md:mb-12">
    <div class="z-grid__cols z-grid__content relative z-10 bg-white rounded-3xl pt-8">
      <div id="hubspot-form"></div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  formId: { type: String, required: true },
})

/*
 * Provided by the HubSpot embed script loaded below, never by this app; declared here so the call in
 * its onload handler type-checks.
 */
declare global {
  interface Window {
    hbspt: { forms: { create: (_options: { portalId: string; formId: string; target: string }) => void } }
  }
}

onMounted(() => {
  const script = document.createElement('script')
  script.charset = 'utf-8'
  script.type = 'text/javascript'
  script.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js'
  script.onload = () => {
    window.hbspt.forms.create({
      portalId: '143918352',
      formId: props.formId,
      target: '#hubspot-form',
    })
  }
  document.body.appendChild(script)
})
</script>
